<template>
  <div class="form-group" @click="onClick" :class="{ mobile: isMobile() }">
    <div class="checkbox" :class="this.value ? 'active' : ''">
      <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 5L5 9L13 1" stroke="white" stroke-width="2"/>
      </svg>
    </div>
    <label class="body-regular gray-600" v-if="this.label">{{ label }}</label>
  </div>
</template>

<script>
import UtilMixin from '@/mixins/util';

export default {
  name: 'app-checkbox',
  mixins: [UtilMixin],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  methods: {
    onClick() {
      this.$emit('input', !this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-group {
  display: flex;
  justify-content: center;

  label {
    padding-left: 12px;
  }

  .checkbox {
    width: 20px;
    height: 20px;
    border: 1px solid var(--primary);
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    &.active {
      background-color: var(--primary);
    }
  }

  &.mobile {
    label {
      padding-left: 8px;
    }

    .checkbox {
      min-width: 24px;
      min-height: 24px;
    }
  }
}
</style>
